<template>
    <v-container>
        <presidents-speakers :positionType="3709" :memberOrSenator="'member'" pageHeader="true" header="Speakers"></presidents-speakers>
        <br/>
        <presidents-speakers :positionType="3699" :memberOrSenator="'member'" header="Chairs of Committees"></presidents-speakers>
        <br/>
        <presidents-speakers :positionType="3704" :memberOrSenator="'member'" header="Deputy Speakers"
            subHeader="The Deputy Speaker’s former titles of ‘Chairman of Committees’ or ‘Chairs of Committees’ were dropped with the abolition of the committee of the whole in 1994."></presidents-speakers>
        <br/>
        <presidents-speakers :positionType="3708" :memberOrSenator="'member'" header="Second Deputy Speakers"
            subHeader="The office of Second Deputy Speaker was created in 1994 with the establishment of the Main Committee, the precursor to the Federation Chamber."></presidents-speakers>
    </v-container>
</template>
<script>
import PresidentsSpeakers from './PresidentsSpeakers.vue'

export default {
    data() {
        return {
            title: 'Speakers and Deputy Speakers'
        }
    },
    components: {
        PresidentsSpeakers
    }
}
</script>
<style scoped>
    .v-datatable {
        margin-bottom: 1rem;
    }
    h2 {
        margin-bottom: 1rem;
    }
</style>